import { createReducer, on } from '@ngrx/store';
import {
  getOrgManagement,
  saveOrgManagement,
  updateOrgManagement,
  storeGitToken,
  deleteOrgManagement,
  setOrgManagement,
  sentOrgManagement,
  sentDeleteOrgManagement,
  getOrManagementBasedOnSearch,
  setSidBasedOrManagement,
  getSidBasedOrManagement,
  getErrorMessage,
  testGitConnection,
  testGitConnectionComplete,
  getOrgDataForHeader,
  getOrglistforHeader,
  setOrgDataForHeader,
  setOrglistforHeader,
  setOrgManagementWithSorting,
  clearSearchText,
  deleteOrgManagementSuccess,
  deleteOrgManagementFailure,
  activateOrganization,
  deactivateOrganization,
  setOrgDelorDeactiveState
} from '../actions/orgmanagement.action';

export interface OrgManagementState {
  data: any;
  loader: boolean;
  orgHeaderLoader: boolean;
  sidOrgManagementData: any;
  searchText: any;
  orglistForHeader: any;
  orgDataForHeader: any;
  searchTextForHeader: any;
  selectedOrgDeleted: any;
}

export const initialState: OrgManagementState = {
  data: [],
  loader: false,
  orgHeaderLoader: false,
  sidOrgManagementData: null,
  orglistForHeader: null,
  orgDataForHeader: null,
  searchText: '',
  searchTextForHeader: '',
  selectedOrgDeleted: false
};

export const orgManagementReducer = createReducer(
  initialState,
  on(getOrgManagement, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants,
    sidOrgManagementData: null,
    searchText: '',
    loader: true
  })),
  on(setOrgManagement, (state, { organizationData, totalRecords }) => ({
    ...state,
    data: { organizationData, totalRecords },
    sidOrgManagementData: null,
    loader: false
  })),
  on(setOrgManagementWithSorting, (state, { organizationData, totalRecords }) => ({
    ...state,
    data: { organizationData, totalRecords },
    sidOrgManagementData: null,
    loader: false
  })),
  on(sentOrgManagement, (state) => ({
    ...state,
    loader: true
  })),
  on(saveOrgManagement, (state, { organizationData }) => {
    const allData = state.data.length > 0 ? [...state.data, organizationData] : [organizationData];
    return {
      ...state,
      data: allData,
      sidOrgManagementData: null,
      loader: false
    };
  }),
  on(clearSearchText, (state, { searchText }) => {
    return {
      ...state,
      searchText
    };
  }),
  on(updateOrgManagement, (state, { organizationData }) => {
    let allData: any[] = [];
    let headerData: any[] = [];
    if (state.data?.organizationData?.length) {
      const toBeFilteredData = [...state.data.organizationData];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData?.findIndex((app) => app?.sid === organizationData?.sid);

      if (updateIndex === -1) {
        allData.unshift(organizationData);
      } else {
        allData[updateIndex] = organizationData;
      }
    } else {
      allData = [organizationData];
    }
    if (state.orglistForHeader.length > 0) {
      if (organizationData?.sid && organizationData?.status === 'DEACTIVE') {
        const toBeFilteredData = [...state.orglistForHeader];
        headerData = toBeFilteredData;
        const updateIndex = toBeFilteredData?.findIndex((app) => app?.sid === organizationData?.sid);
        if (updateIndex !== -1) {
          headerData.splice(updateIndex, 1);
        }
      } else {
        headerData = state.orglistForHeader;
        if (
          state.searchTextForHeader !== '' &&
          organizationData?.name.toLowerCase().includes(state.searchTextForHeader.toLowerCase()) &&
          organizationData?.status !== 'DEACTIVE'
        ) {
          headerData = [...headerData, organizationData];
        }
      }
    } else {
      headerData = allData;
    }
    return {
      ...state,
      data: { organizationData: allData, totalRecords: allData.length },
      sidOrgManagementData: organizationData,
      orglistForHeader: headerData,
      loader: false
    };
  }),
  on(storeGitToken, (state, { gitToken }) => ({
    ...state,
    loader: false
  })),
  on(sentDeleteOrgManagement, (state, { apiConstants, organizationId }) => ({
    ...state,
    loader: false
  })),
  on(testGitConnection, (state, { testGitToken }) => ({
    ...state,
    loader: true
  })),
  on(testGitConnectionComplete, (state) => ({
    ...state,
    loader: false
  })),
  on(deleteOrgManagement, (state, { organizationId }) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(deleteOrgManagementSuccess, (state, { organizationId, selectedOrg }) => {
    const organizationData = state.data.organizationData;
    const selectedOrgDeleted = selectedOrg === organizationId;
    const filteredData = organizationData.filter(
      (organization: { sid: string }) => organization.sid !== organizationId
    );
    return {
      ...state,
      data: { organizationData: filteredData, totalRecords: filteredData.length },
      orglistForHeader: filteredData,
      loader: false,
      selectedOrgDeleted: selectedOrgDeleted
    };
  }),
  on(activateOrganization, (state, { organizationId }) => {
    let allData: any[] = [];
    if (state.data.organizationData.length) {
      const toBeFilteredData = [...state.data.organizationData];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData?.findIndex((app) => app?.sid === organizationId);
      if (updateIndex !== -1) {
        const orgData = { ...state.data.organizationData[updateIndex], status: 'ACTIVE' };
        allData[updateIndex] = orgData;
      }
    }
    return {
      ...state,
      selectedOrgDeleted: false,
      data: { organizationData: allData, totalRecords: allData.length },
      loader: true
    };
  }),
  on(deactivateOrganization, (state, { organizationId, selectedOrg }) => {
    const selOrg = selectedOrg === organizationId;
    let allData: any[] = [];
    if (state.data.organizationData.length) {
      const toBeFilteredData = [...state.data.organizationData];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData?.findIndex((app) => app?.sid === organizationId);
      if (updateIndex !== -1) {
        const orgData = { ...state.data.organizationData[updateIndex], status: 'DEACTIVE' };
        allData[updateIndex] = orgData;
      }
    }
    return {
      ...state,
      data: { organizationData: allData, totalRecords: allData.length },
      selectedOrgDeleted: selOrg,
      loader: true
    };
  }),
  on(deleteOrgManagementFailure, (state) => {
    return {
      ...state,
      loader: false
    };
  }),
  on(getSidBasedOrManagement, (state) => {
    return {
      ...state,
      loader: true,
      sidOrgManagementData: null
    };
  }),
  on(setSidBasedOrManagement, (state, { sidOrgManagementData }) => {
    return {
      ...state,
      loader: false,
      sidOrgManagementData: sidOrgManagementData
    };
  }),
  on(getOrManagementBasedOnSearch, (state, { searchFields }) => {
    return {
      ...state,
      searchFields,
      loader: true
    };
  }),
  on(getErrorMessage, (state, errorMessage) => {
    return {
      ...state,
      errorMessage,
      loader: false
    };
  }),
  on(getOrgDataForHeader, (state, { orgApi }) => {
    return {
      ...state,
      ...orgApi,
      selectedOrgDeleted: false,
      orgDataForHeader: null,
      orgHeaderLoader: true
    };
  }),
  on(setOrgDataForHeader, (state, { orgDataForHeader }) => {
    let orgHeaderData = orgDataForHeader;
    if (orgDataForHeader.status === 'DEACTIVE') {
      orgHeaderData = null;
    }
    return {
      ...state,
      selectedOrgDeleted: false,
      orgDataForHeader: { ...orgHeaderData },
      orgHeaderLoader: false
    };
  }),
  on(getOrglistforHeader, (state, { apiConst }) => {
    return {
      ...state,
      ...apiConst
    };
  }),
  on(setOrglistforHeader, (state, { orglistForHeader, searchText }) => {
    let filteredData = [];
    filteredData = orglistForHeader.filter((org) => org.status === null || org.status === 'ACTIVE');
    return {
      ...state,
      searchTextForHeader: searchText,
      orglistForHeader: [...filteredData]
    };
  }),
  on(setOrgDelorDeactiveState, (state, { organizationId, selectedOrgDeleted }) => {
    return {
      ...state,
      orgId: organizationId
    };
  })
);
